import React from 'react';
import classnames from 'classnames';

import styles from './LabelFlair.scss';

const LabelFlair = (props) => {
  return (
    <label className={classnames(styles.label, styles[props.type], styles[props.size])}>
      {props.children}
    </label>
  );
};

LabelFlair.propTypes = {
  /** Label Text */
  children: React.PropTypes.any.isRequired,
  /** Label Type (color) */
  type: React.PropTypes.oneOf(['new', 'notice', 'warn', 'error']),
  /** Label Size */
  size: React.PropTypes.oneOf(['small', 'medium', 'large'])
};

LabelFlair.defaultProps = {
  type: 'new',
  size: 'small'
};

export default LabelFlair;



// WEBPACK FOOTER //
// ./src/components/flairs/components/LabelFlair.jsx